<script setup lang="ts">
import Button from '../Button.vue';

const props = defineProps<{
	title?: string;
	closeLabel?: string;
	isActive?: boolean;
}>();

const emit = defineEmits<{
	'update:isActive': [value: boolean];
	'close': [];
}>();

const closeMore = () => {
	emit('update:isActive', false);
	emit('close');
};
</script>

<template>
	<div
		class="bottom-dialog-more"
		role="document"
		id="bottom-dialog-more"
	>
		<div class="bottom-dialog-more__header">
			<span
				class="bottom-dialog-more__title"
				id="bottom-dialog-more-title"
			>
				{{ props.title }}
			</span>
			<Button
				:aria-label="props.closeLabel"
				icon="x"
				severity="error"
				size="sm"
				@click="closeMore()"
			/>
		</div>
		<div class="bottom-dialog-more__body">
			<slot />
		</div>
		<div class="bottom-dialog-more__footer" v-if="$slots.footer">
			<slot name="footer" />
		</div>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.bottom-dialog-more
	{
		@include flex;
		flex-direction:column;

		&__header
		{
			@include flex(between, center, var(--spacing-md));
			border-block-end:1px solid var(--border-primary);
			padding-block-end:var(--spacing-xs);
		}
		&__title
		{
			color:var(--c-body);
			@include text-body(md);
			font-weight:500;
		}
		&__body
		{
			@include flex;
			flex-direction:column;
			max-height:calc(100dvh - 17.6rem);
			padding:var(--spacing-lg) 0;
			overflow-y:auto;

			@include responsive(lg)
			{
				max-height:calc(100dvh - 20rem);
				padding-inline:var(--spacing-xs);
			}
		}
		&__footer
		{
			@include flex(end, center, var(--spacing-2xs));
			border-block-start:1px solid var(--border-primary);
			padding-block-start:var(--spacing-xs);
		}
	}
}
</style>
